import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import DoughnutChart from "./DoughnutChart";
import Common from "./../../common.json";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});

export default function Sectoranalysis() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [getRec, setgetRec] = useState(false);
  const [column, setcolumn] = useState(1);
  const [symbol, setsymbol] = useState({});
  const [cp, setcp] = useState({});
  const [color, setcolor] = useState({});
  const [bcolor, setbcolor] = useState({});
  const allsymbols = [];
  const allcp = [];
  const allcolor = [];
  const allbcolor = [];

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getsectorAnalysisData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.response.getAllData);
        setgetRec(response.data.response.getRec);
        const arrayData = response.data.response.getRec;

        arrayData.forEach((item) => {
          allsymbols.push(item.symbol + " (" + item.cp + ")");
          allcp.push(parseFloat(item.cp));
          if (item.cp < 0) {
            allcolor.push("rgb(244, 67, 54)");
          } else {
            allcolor.push("rgb(76, 175, 80)");
          }
          allbcolor.push("rgb(255,255,255)");
        });
        setcp(allcp);
        setsymbol(allsymbols);
        setcolor(allcolor);
        setbcolor(allbcolor);
      },
      mobile,
      web_token
    );
  }, [column, mobile, web_token]);

  return (
    <>
      <GlobalHelmet {...Common?.sectorAnalysis} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Sector Analysis" />

              <div className={classes.root}>
                <div className=" ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className=" ">
                        <div className="row ">
                          <div className="col-7">
                            <h3>
                              <span className="highlighttext">
                                Sector Analysis
                              </span>
                            </h3>
                          </div>
                          <div className="col-5 text-right">
                            <button
                              className="btn btn-success"
                              title="Reload Page"
                              onClick={refreshPage}
                            >
                              <i className="fa fa-refresh"></i>
                            </button>
                            &nbsp;
                            <Link
                              className="btn btn-success"
                              to="/stock-market-today"
                            >
                              <i className="fa fa-arrow-left"></i>
                            </Link>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 pt-4">
                            {getRec ? (
                              <div className="table-responsive">
                                <table className="table table-bordered tableSectorAnalysis">
                                  <thead>
                                    <tr className="header-row changefont">
                                      <th className="indexname" size="3">
                                        Symbol
                                      </th>
                                      <th className="ltp" size="3">
                                        1D
                                      </th>
                                      <th className="signal" size="3">
                                        1W
                                      </th>
                                      <th className="change" size="3">
                                        1M
                                      </th>
                                      <th className="change" size="3">
                                        3M
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {getRec.map((item, key) => (
                                      <tr key={key}>
                                        <td
                                          className="indexname symbol-text"
                                          size="4"
                                        >
                                          <Link
                                            to={
                                              "/sector-analysis/" +
                                              item.market_id
                                            }
                                          >
                                            {item.symbol}
                                          </Link>
                                        </td>
                                        <td
                                          className="indexname symbol-text"
                                          size="2"
                                          style={{ color: item.color }}
                                        >
                                          {item.cp}
                                        </td>
                                        <td
                                          className="indexname symbol-text"
                                          size="2"
                                          style={{ color: item.wcolor }}
                                        >
                                          {item.weekper}
                                        </td>
                                        <td
                                          className="indexname symbol-text"
                                          size="2"
                                          style={{ color: item.onecolor }}
                                        >
                                          {item.onemonthper}
                                        </td>
                                        <td
                                          className="indexname symbol-text"
                                          size="2"
                                          style={{ color: item.threecolor }}
                                        >
                                          {item.threemonthper}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-md-6 pt-4">
                            <DoughnutChart
                              allsymbols={symbol}
                              allcp={cp}
                              color={color}
                              bcolor={bcolor}
                            />
                          </div>

                          <div className="col-12 ">
                            <hr />
                            <div className="row addpadding">
                              {globaldata
                                ? globaldata.map((item, key) => (
                                    <div className="col-sm-6 " key={key}>
                                      <div className="row">
                                        <div className="col-12 add-col-border">
                                          <b>{item.sector_name}</b>
                                          <span>({item.upstocks}%)</span>
                                        </div>
                                        <div className="col-12 add-col-border">
                                          <b>Symbol</b>
                                          <span>%CHG</span>
                                          <hr />
                                          {item.getDetails
                                            ? item.getDetails.map(
                                                (child, childKey) => (
                                                  <p key={childKey}>
                                                    <b>{child.symbol} </b>
                                                    <span>{child.cp} %</span>
                                                  </p>
                                                )
                                              )
                                            : ""}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
